import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
  import NewReleaseVersion from '@/components/common/NewReleaseVersion.vue'
  import { UserModule } from '@/store/modules/user'
  import CustomWidgetsWrapper from '@/components/common/CustomWidgetsWrapper.vue'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CustomCompanyWidgets',
  props: {
    calendlyWidgetHeight: {
      type: Number,
      default: 0,
    },
  },
  setup(__props) {

const props = __props;

  
  const widgetsBottomPixels = computed(() => {
    return props.calendlyWidgetHeight > 0 ? `${props.calendlyWidgetHeight + 30}px` : '20px'
  })

  const companyWidgets = computed(() => UserModule.currentCompany?.widgets)

  const filteredWidgets = computed(() =>
    companyWidgets.value
      ?.filter((widget) => widget.type !== 'calendly' && widget.url && widget.displayText)
      .sort((a, b) => a.orderingNumber - b.orderingNumber),
  )

return { __sfc: true,props, widgetsBottomPixels, companyWidgets, filteredWidgets, computed, NewReleaseVersion, UserModule, CustomWidgetsWrapper }
}

})